



































































import { Component, Prop, Vue } from 'vue-property-decorator';
import DialogList from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box3/dialog-1.vue';
import { zyScreenServer } from '@/api/installServer';
@Component({
  components: { DialogList },
})
export default class Box1 extends Vue {
  private dataForm: any = {
    high: 0,
    hoisting: 0,
    acid: 0,
    space: 0,
    fire: 0,
    electricity: 0,
  };
  private deptId: any = '';
  mounted() {
    this.getData({});
  }
  getData(opts: any) {
    const userInfo: any = localStorage.getItem('userInfo');
    const info: any = JSON.parse(userInfo);
    this.deptId = opts.deptId || info.deptId;
    zyScreenServer
      .getWorkCountData({ deptId: this.deptId })
      .then((res: any) => {
        this.dataForm = res.data;
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
  /**
   * @desc 打开开展情况弹窗
   */
  showDialog(type: any) {
    const dataForm: any = {
      deptId: this.deptId,
      type,
    };
    const refName = 'DialogListRef';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(dataForm);
  }
}
